import { Button } from '@mui/material';
import { useFormik } from 'formik';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getNewsByIdFn, patchNewsFn, postNewsFn } from 'Services/News';
import CustomInput from 'Shared/CustomInput';
import ImageInput from 'Shared/ImageInput';
import RichTextEditor from 'Shared/RichTextEditory';

const AddUpdateNews = () => {
    const navigate = useNavigate();
    const { id, status } = useParams();

    const { data: response } = useQuery({
        queryKey: ['get-news-by-id', id, status],
        queryFn: () => getNewsByIdFn(id),
        enabled: !!id && status === "update"
    });
    const data = response?.data?.data;


    const { mutate: post } = useMutation(postNewsFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/news/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const { mutate: patch } = useMutation(patchNewsFn, {
        onSuccess: (response) => {
            toast.success(response?.data?.message);
            navigate('/news/');
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message);
        }
    });

    const initialValues = {
        image: "",
        title: data?.title || "",
        content: data?.content || "",
        location: data?.location || ""
    };

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: (values) => {
            if (!values.title) return toast.error("Title is required.");
            if (!values.content) return toast.error("Content is required.");
            if (!values.location) return toast.error("Loacation is required.");

            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('location', values.location);
            formData.append('content', values.content);

            if (status === 'add') {
                if (!values.image) return toast.error("Image is required.");
                formData.append('image', values.image);
                post(formData);
            } else {
                if (values.image) formData.append('image', values.image);
                formData.append("news_id", id);
                patch(formData);
            }
        }
    });

    return (
        <div className="p-4">
            <form
                className="bg-white shadow-md rounded-lg mx-auto p-6 flex flex-col gap-6"
                onSubmit={formik.handleSubmit}
            >
                <p className="text-xl text-black font-bold text-center">
                    {status === "update" ? "Update" : "Add"} News
                </p>
                <CustomInput formik={formik} label="Title" name="title" />
                <CustomInput formik={formik} label="Loacation" name="location" />
                <ImageInput formik={formik} label="Image" name="image" />
                <RichTextEditor formik={formik} label={"Content"} name={"content"} />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                >
                    {status === "update" ? "Update" : "Add"}
                </Button>
            </form>
        </div>
    );
};

export default AddUpdateNews;
